export const DEFAULT_RENTAL_UNITS_OVERVIEW_IDENTIFIER =
  "cb-portfolio-object-stackingplan";
